import { simpleSet } from '@r/reducers/utils';

export const doorLabourUnit = simpleSet(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_DOOR_LABOUR_UNIT',
  0
);
